module.exports = __webpack_public_path__ + "static/media/zind_rugarama8.077f86f8.jpg";